import React from "react";
import { LineChart } from "@mui/x-charts";
import { useSelector } from "react-redux";
export default function LineChartHome() {
  const yearStats = useSelector((state) => state.year_stats);
  const year = [];
  const cost = [];
  const interest = [];
  yearStats.map((data) => {
    // eslint-disable-next-line no-sequences
    return (
      year.push(data._id), cost.push(data.cost), interest.push(data.interest)
    );
  });

  return (
    <LineChart
      width={400}
      height={200}
      series={[
        { data: cost, label: "cost", color: "#3D4F58" },
        { data: interest, label: "interest", color: "#17B859" },
      ]}
      xAxis={[{ scaleType: "point", data: year }]}
    />
  );
}
